import React from "react";
import { Link, useLocation } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const SidebarMenuGroup = ({
  isSidebarOpen,
  icon: IconComponent,
  label,
  basePath,
  submenuOpen,
  setSubmenuOpen,
  submenuItems = []
}) => {
  const location = useLocation();
  const isActive = location.pathname.startsWith(basePath);

  const handleMainClick = () => {
    setSubmenuOpen(!submenuOpen);
  };

  return (
    <li className={`${label.toLowerCase().replace(/\s+/g,'')}-menu`}>
      <div
        className={`admin-toggle ${submenuOpen ? "active" : ""}`}
        onClick={handleMainClick}
      >
        <div className="toggle-content">
          <IconComponent className="sidebar-icon" />
          {isSidebarOpen && <span>{label}</span>}
        </div>
        {isSidebarOpen && (
          submenuOpen
            ? <ExpandLessIcon fontSize="small" />
            : <ExpandMoreIcon fontSize="small" />
        )}
      </div>

      {isSidebarOpen && submenuOpen && (
        <ul className="admin-submenu show">
          {submenuItems.map(item => (
            <li key={item.path}>
              <Link
                to={item.path}
                className={location.pathname === item.path ? "active-link" : ""}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

export default SidebarMenuGroup;